import { render } from "./_form-phoneoks.vue?vue&type=template&id=2f3dd1a2"
import script from "./_form-phoneoks.vue?vue&type=script&lang=js"
export * from "./_form-phoneoks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__